<template>
    <div class="case">
        <div class="case-container">
            <h1>/ Subscription Manager /</h1>
            <p class="case-intro">Subs! is a subscription manager which can be arrange all your online subscriptions in one place.</p>
            <img src="../../assets/case5-1.png" class="wide" alt="">
            <p>Here is the Figma prototypes:</p>
            <div class="figma">
                <iframe style="border: none;" width="800" height="450" src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2F4TnbuEuGfTZYrCvxTcOKs9%2Fsub%3Fnode-id%3D8%253A0%26viewport%3D419%252C-44%252C0.11194030195474625%26scaling%3Dscale-down" allowfullscreen></iframe>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            test:'test'
        }
    }
    
}
</script>
<style lang="scss" scoped>
    
</style>